import { Nullable, SelectOption } from '$models'
import dayjs, { Dayjs } from 'dayjs'

export interface StaffRole {
  id: string
  posIdentifier: Nullable<string>
  name: string
  costGroup: Nullable<string>
  deptCode: string
  datestampCreated: Dayjs
  datestampDeleted: Nullable<Dayjs>
}

export const transformStaffRoleOnGet = (staffRole: StaffRole): StaffRole => {
  return {
    ...staffRole,
    datestampCreated: dayjs(staffRole.datestampCreated),
    datestampDeleted: staffRole.datestampDeleted
      ? dayjs(staffRole.datestampDeleted)
      : null,
  }
}
export const transformStaffRoleOnSave = (staffRole: StaffRole): object => {
  return {
    ...staffRole,
    datestampCreated: staffRole.datestampCreated.utc(),
    datestampedDeleted: staffRole.datestampDeleted
      ? staffRole.datestampDeleted.utc()
      : null,
  }
}

export const getStaffRolesAsOptions = (
  staffRoles: StaffRole[]
): SelectOption[] =>
  staffRoles.map((staffRole) => {
    return {
      label: staffRole.name,
      value: staffRole.id,
    }
  })
